import classes from './CargoItem.module.sass'

import { format } from 'date-fns'
import { ImageGallery } from '../../../common/components/imageGallery/ImageGallery'
import { useCargoItem } from './hooks/useCargoItem'
import { GMapForRoute } from '../../../common/components/maps/gMapForRoute/GMapForRoute'
import { StatusMenu } from '../../../common/components/statusMenu/StatusMenu'
import { Helmet } from 'react-helmet-async'
import { StartChat } from '../../../common/components/startChat/StartChat'
import { Group, Status } from '../../../common/types/enums'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../store/slices/currentUserSlice'
import { ViewContact } from '../../../common/components/viewContact/ViewContact'
import { TypesSection } from '../../../common/components/typesSection/TypesSection'
import { CargoTypesSection } from '../../../common/components/cargotTypesSection/CargoTypesSection'
import QRCode from 'react-qr-code'
import { CargoUnitItem } from './components/cargoUnitItem/CargoUnitItem'

export const CargoItem = () => {
  const { item, toggleSelected } = useCargoItem()
  const currentUser = useSelector(selectCurrentUser)

  if (item)
    return (
      <div className={classes.Container}>
        <Helmet>
          <title>{`logid - груз. ${item.name}${
            item.points ? `, ${item?.points[0]?.city.value}` : ''
          }`}</title>
          <meta
            name="description"
            content={`logid - груз. ${item.description} ${
              item.points ? `${item?.points[0]?.city.value}` : ''
            }`}
          />
        </Helmet>

        <div className={classes.Card}>
          <StatusMenu
            item={item}
            selectedClick={() => {
              toggleSelected(item)
            }}
            selected={Boolean(item.selected?.find((el: any) => el.user_id === currentUser?.id))}
          />

          <div className={classes.Name}>
            
            <span className={classes.Label}>Груз</span> {item && item.name}
          </div>
          <div className={classes.Description}>
            
            <span className={classes.Label}>Описание</span> {item && item.description}
          </div>

          {item.points && (
            <>
              <div className={classes.City}>
                
                <span className={classes.Label}>Город</span>
                {item.points[0].city.value}
              </div>
              {item.points[0].address && (
                <div className={classes.Address}>
                  
                  <span className={classes.Label}>Адрес</span>
                  {item.points[0].address.value}
                </div>
              )}
            </>
          )}

          {item.points &&
            item.points.length > 2 &&
            item.points.slice(1, item.points.length - 1).map((el, index) => (
              <>
                {/* {item.points && el.city.value !== item.points[0].city.value && ( */}
                <div className={classes.City}>
                  
                  <span className={classes.Label}>{`Город точка ${index + 2}`}</span>
                  {el.city.value}
                </div>
                {/* )} */}

                {el.address && (
                  <div className={classes.Address}>
                    
                    <span className={classes.Label}>{`Адрес точка ${index + 2}`}</span>
                    {el.address.value}
                  </div>
                )}
              </>
            ))}

          {item.points && item.points.length > 1 && (
            <>
              {/* {item.points &&
                item.points[item.points.length - 1].city.value !== item.points[0].city.value && ( */}
              <div className={classes.City}>
                
                <span className={classes.Label}>Город</span>
                {item.points[item.points.length - 1].city.value}
              </div>
              {/* )} */}
              {item.points[item.points.length - 1].address && (
                <div className={classes.Address}>
                  
                  <span className={classes.Label}>Адрес</span>
                  {item.points[item.points.length - 1].address.value}
                </div>
              )}
            </>
          )}
          {item.start_important && (
            <div className={classes.Time}>
              
              <span className={classes.Label}>Дата и время подачи</span>
              {format(item.startTime, 'dd.MM.yyyy HH:mm')}
            </div>
          )}

          {item.end_important && (
            <div className={classes.Time}>
              
              <span className={classes.Label}>Дата и время завершения</span>
              {format(item.endTime, 'dd.MM.yyyy HH:mm')}
            </div>
          )}

          <div className={classes.Cost}>
            
            <span className={classes.Label}>Ставка</span>
            {item.cost ? `${new Intl.NumberFormat('ru-RU').format(Number(item.cost))} ₽`: 'Не указана'}
          </div>

          {currentUser?.id !== item.userId && item.id && (
            <StartChat order={item} group={Group.CARGO} />
          )}
          {currentUser?.id === item.userId && item.status === Status.IN_WORK && item.id && (
            <StartChat order={item} group={Group.CARGO} />
          )}

          <div className={classes.TypesSection}>
            <TypesSection item={item} />
            <CargoTypesSection item={item} />
          </div>

          <div className={classes.GalleryQr}>
            <ImageGallery urls={item.files} />
            <QRCode value={window.location.href} size={128} className={classes.Qr} />
          </div>

          {item.cargo_units.length > 0 && (
            <div className={classes.CargoUnitsList}>
              <div className={classes.UnitsTitle}>Грузовые места</div>
              {item.cargo_units.map((el) => (
                <CargoUnitItem el={el} key={el.id} />
              ))}
            </div>
          )}

          <div className={classes.BottomSection}>
            
            <ViewContact
              visible={currentUser?.id === item.userId}
              viewData={item.views}
              contactData={item.contacts ? item.contacts : []}
              selectedData={item.selected ? item.selected : []}
            />
            {item.createdAt && item.userId === currentUser?.id && (
              <div className={classes.Id}>
                {format(new Date(item.createdAt), 'dd.MM.yyy HH:mm')}
              </div>
            )}
            <div className={classes.Id}>{item.id}</div>
          </div>
        </div>
        <div className={classes.MapContainer}>
          <GMapForRoute data={item} intercity={Boolean(item.intercity)} />
        </div>
      </div>
    )
  return <></>
}
